import * as types from "../ActionType";
import axios from "axios";
import { notifyError , notifysuccess } from "../../components/general/Notification";
import { hasExpirition } from "../../components/general/general-component/abstruct-component/useExpirition";
const END_POINT = process.env.REACT_APP_BASE_URL_WAREHOUSE;

const get = (arr,type) => {
    return ({
        type: type,
        payload: arr
    })
}
const add = (type) => {
    return ({
        type: type
    })
}
const delelte = (type) => {
    return ({
        type: type
    })
}
const edit= (type) => {
    return ({
        type: type 
    })
}
const emptyGeneral = (empty, typee) => {
    return ({
        type: typee,
        payload: empty
    })
}

export const postProduct = (state,files,descriptions,setLoad) => {
    return function (dispatch) {
        setLoad(true)
        let token = localStorage.getItem("tokenA");
        const body={
            name: state.name,
            material_category_id: state.material_category_id,
            material_sub_category_id: state.material_sub_category_id,
            warehouse_id: state.warehouse_id,
            description: state.description,
            sn: state.sn,
            notes: state.notes,
            status: state.status,
            type: state.type,
            brand: state.brand,
            model: state.model,
            files: files,
            descriptions: descriptions
        }
        console.log(body)
        axios.post(`${END_POINT}/api/materials`, body, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status === "Success") {
                dispatch(add(types.ADD_PRODUCT));
                dispatch(loadProducts());
                notifysuccess(res.data.message)
                setLoad(false)
            }
        }).catch((err) => {
            setLoad(false)
            notifyError(err.response.data.message)
        })
    }
}
export const assignProduct = (state,setLoad) => {
    return function (dispatch) {
        setLoad(true)
        let token = localStorage.getItem("tokenA");
        console.log(state)
        axios.post(`${END_POINT}/api/materials/zones`, state, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status === "Success") {
                dispatch(add(types.ASSIGN_PRODUCT_TO_ZONE));
                dispatch(loadProductsByZone(state?.warehouse_zone_id));
                notifysuccess(res.data.message)
                setLoad(false)
            }
        }).catch((err) => {
            setLoad(false)
            notifyError(err.response.data.message)
        })
    }
}
export const loadProducts = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${END_POINT}/api/materials`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res.data.data,types.GET_PRODUCTS));
            }
        }).catch((err) => {
            notifyError(err.response.data.message)
        })
    }
}
export const loadProductsByZone = (warehouse_zone_id) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${END_POINT}/api/materials/zones?filters[warehouse_zone_id]=${warehouse_zone_id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res.data.data,types.GET_PRODUCTS_BY_ZONE));
            }
        }).catch((err) => {
            notifyError(err.response.data.message)
        })
    }
}
export const emptyProductsByZone = () => {
    return function (dispatch) {
        let emptyy = []
        dispatch(emptyGeneral(emptyy, types.EMPTY_PRODUCTS_BY_ZONE))
    }
}
export const loadOneProduct = (id) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${END_POINT}/api/materials/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                console.log(res)
                dispatch(get(res.data.data,types.GET_ONE_PRODUCT));
            }
        }).catch((err) => {
           // notifyError(err.response.data.message)
        })
    }
}

export const emptyOneProduct = () => {
    console.log('emptyyyyyyyyyyyyyyyyy')
    return function (dispatch) {
        let emptyy = []
        dispatch(emptyGeneral(emptyy, types.EMPTY_ONE_PRODUCT))
    }
}

export const loadProductsByWarehouse = (id_warehouse) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        console.log(id_warehouse)
        /*axios.get(`${END_POINT}/api/users`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res.data.data,types.GET_PRODUCTS));
            }
        }).catch((err) => {
            notifyError(err.response.data.message)
        })*/
    }
}

export const deleteProduct = (id,setloadDel,setIsDeleted,setIdDeleted) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        setloadDel(true)
        axios.delete(`${END_POINT}/api/users/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(delelte(types.DELETE_PRODUCT));
                notifysuccess(res.data.message)
                setIsDeleted('deleted')
                setIdDeleted(id)
                setloadDel(false)
            }
        }).catch((err) => {
            setloadDel(false)
            notifyError(err.response.data.message)
        })
    }
}

export const putProduct = (id,state,descriptions,setLoad) => {
    return function (dispatch) {
        setLoad(true)
        let token = localStorage.getItem("tokenA");
        const body={
            name: state.name,
            material_category_id: state.material_category_id,
            material_sub_category_id: state.material_sub_category_id,
            warehouse_id: state.warehouse_id,
            description: state.description,
            sn: state.sn,
            notes: state.notes,
            status: state.status,
            type: state.type,
            brand: state.brand,
            model: state.model,
            descriptions: descriptions
        }
        console.log(body)
        axios.put(`${END_POINT}/api/materials/${id}`,body, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status === "Success") {
                dispatch(edit(types.EDIT_PRODUCT));
                dispatch(loadProducts());
                notifysuccess(res.data.message)
                setLoad(false)
            }
        }).catch((err) => {
            setLoad(false)
            notifyError(err.response.data.message)
        })
    }
}


export const filterProduct = (name,email,role, setLoad) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA")
        setLoad(true);
        const queryParams = [];
        if (name !== '') queryParams.push(`filters[name]=${name}`);
        if (email !== '') queryParams.push(`filters[email]=${email}`);
        if (role !== '') queryParams.push(`filters[role]=${role}`);
        const finalQuery = queryParams.join('&');
        const apiUrl = `${END_POINT}/api/users?${finalQuery}`;
        axios.get(apiUrl, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then((res) => {
            setLoad(false);
             dispatch(get(res.data.data,types.GET_PRODUCTS));
        }).catch((err) => {;
            setLoad(false);
        });
    };
};


